import { TextinputButton } from './TextinputButton';

export type { TypeTextinputButtonProps } from './types';
export default TextinputButton;
